/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetExpensePartnerResponse
 */
export interface AssetExpensePartnerResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetExpensePartnerResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetExpensePartnerResponse
     */
    caseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AssetExpensePartnerResponse
     */
    salutation: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetExpensePartnerResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AssetExpensePartnerResponse
     */
    lastName: string;
}

/**
 * Check if a given object implements the AssetExpensePartnerResponse interface.
 */
export function instanceOfAssetExpensePartnerResponse(value: object): value is AssetExpensePartnerResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('caseNumber' in value) || value['caseNumber'] === undefined) return false;
    if (!('salutation' in value) || value['salutation'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function AssetExpensePartnerResponseFromJSON(json: any): AssetExpensePartnerResponse {
    return AssetExpensePartnerResponseFromJSONTyped(json, false);
}

export function AssetExpensePartnerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetExpensePartnerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'caseNumber': json['caseNumber'],
        'salutation': json['salutation'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function AssetExpensePartnerResponseToJSON(json: any): AssetExpensePartnerResponse {
    return AssetExpensePartnerResponseToJSONTyped(json, false);
}

export function AssetExpensePartnerResponseToJSONTyped(value?: AssetExpensePartnerResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'caseNumber': value['caseNumber'],
        'salutation': value['salutation'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

